<script>
    import { updateTag, deleteTag } from '@/api/tags.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_TAG_EDIT},
        },
        methods: {
            async save() {
                const data = this.$store.getters.TAG_DATA_EDIT;
                const response = await updateTag(data);
                if (response === true) {
                    this.$store.commit('TAGS_UPDATE', {
                        id: data.id,
                        payload: data,
                    })
                    await this.close();
                }
            },
            async deleteObj() {
                const data = this.$store.getters.TAG_DATA_EDIT;
                const response = await deleteTag(data.id);
                if (response === true) {
                    this.$store.commit('PAG_PROVIDER_SPLICE', data.id);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_TAG_EDIT', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        class="button_blue_100"
        @click="save"
    >Save</button>
    <button
        class="button_blue_100 ml_10 button_red"
        @click="deleteObj"
    >Delete</button>
    <button
        class="button_blue_100 close_button mr_10"
        @click="close"
    >Close</button>
</template>